import { ORG, SITE_URL } from './siteConfig';

export function buildOrganizationJsonLd() {
  return {
    '@context': 'https://schema.org',
    '@type': 'LegalService',
    '@id': `${SITE_URL}/#legal-service`,
    name: ORG.legalName,
    alternateName: 'Zöllner Lorenz',
    url: SITE_URL,
    description: 'Termine nach Vereinbarung',
    logo: ORG.logoUrl,
    image: `${SITE_URL}/images/og.jpg`,
    telephone: ORG.telephone,
    email: ORG.email,
    address: {
      '@type': 'PostalAddress',
      streetAddress: ORG.streetAddress,
      postalCode: ORG.postalCode,
      addressLocality: ORG.addressLocality,
      addressCountry: ORG.addressCountry,
    },
    areaServed: {
      '@type': 'City',
      name: 'München',
    },
    knowsAbout: [
      'Familienrecht',
      'Mediation',
      'Cooperative Praxis',
      'Scheidung',
      'Unterhalt',
    ],
    employee: [
      {
        '@type': 'Person',
        name: 'Marlene Zöllner',
        jobTitle: 'Rechtsanwältin, Fachanwältin für Familienrecht',
        url: `${SITE_URL}/team/marlene-zoellner`,
      },
      {
        '@type': 'Person',
        name: 'Susanna Lorenz',
        jobTitle: 'Rechtsanwältin, Mediatorin',
        url: `${SITE_URL}/team/susanna-lorenz`,
      },
    ],
  };
}

export function buildWebSiteJsonLd() {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    '@id': `${SITE_URL}/#website`,
    url: SITE_URL,
    name: 'Zöllner Lorenz – Kanzlei für Familienrecht',
    inLanguage: ['de-DE', 'en'],
    publisher: { '@id': `${SITE_URL}/#legal-service` },
  };
}

/** Combined homepage JSON-LD — single root object (@graph), not a bare array. */
export function buildHomePageJsonLd() {
  const { '@context': _orgContext, ...organization } = buildOrganizationJsonLd();
  const { '@context': _siteContext, ...website } = buildWebSiteJsonLd();

  return {
    '@context': 'https://schema.org',
    '@graph': [organization, website],
  };
}
